import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideToRight = trigger('slideToRight', [
	state('void', style({ transform: 'translateX(100%)' })),
	transition('void <=> *', [animate('0.25s ease-in-out')]),
]);
